<template>
  <div>
    <div class="b-percent-and-period-rate-widget mt-3 p-3">
      <div v-for="(item, index) in widgetItems" class="b-percent-and-period-rate-inputs mt-2">
        <div class="b-percent-and-period-rate-widget__col">
          <label for="comment">{{ $t('CONTENT.currency.increment_percent') }}</label>
          <input
            id="comment"
            v-model.number="item.percentValue"
            min="0"
            max="100"
            type="number"
            class="b-input"
            @change="changeState()">
        </div>
        <div class="b-percent-and-period-rate-widget__col">
          <label class="b-form__container_type_flex">{{ $t('CONTENT.currency.rate_increment') }}</label>
          <datepicker
            v-model="item.startDate"
            class="b-datepicker"
            :formatter="datepickerFormat"
            :disabled-date="wrappedIndexForStartDate(index)"
            @change="changeState()"
          ></datepicker>
        </div>
        <div class="b-percent-and-period-rate-widget__col">
          <datepicker
            class="b-datepicker"
            v-model="item.endDate"
            :formatter="datepickerFormat"
            :disabled-date="wrappedIndexForEndDate(index)"
            :disabled="item.startDate === null"
            @change="changeState()"
          ></datepicker>
        </div>
        <div
          v-if="widgetItems.length > 1"
          class="b-percent-and-period-rate-widget__close-btn">
          <div
            class="close-btn"
            @click="deleteWidgetItems(index)">
            <dynamic-icon class="b-btn__icon" icon="close"></dynamic-icon>
          </div>
        </div>
      </div>
      <div class="row mt-3">
        <div class="col-5">
          <button
            type="button"
            class="b-btn b-btn__color-lightgray"
            @click="addNewPercentAndPeriod"
          >
            <dynamic-icon class="b-btn__icon b-btn__icon_color_main-text" icon="plus"></dynamic-icon>
            {{ $t('CONTENT.currency.add_percent_btn') }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import datepickerFormat from '../../../mixins/datepickerFormat.mixin';
import dateConverter from '../../../utils/converters/date.converter';

export default {
  name: 'PercentAndPeriodRateWidgetWithoutStore',
  mixins: [datepickerFormat],
  props: {
    payment: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      widgetItems: [],
    };
  },
  created() {
    if(this.payment.currencyRateIncreasePercents === null) return
    this.widgetItems = this.payment.currencyRateIncreasePercents.map(item => ({
      percentValue: item.percentValue,
      startDate: dateConverter.convertToDate(item.startDate),
      endDate: dateConverter.convertToDate(item.endDate),
    }));
  },
  methods: {
    changeState() {
      this.widgetItems.forEach((item) => {
        item.percentValue = this.recalculationPercent(item.percentValue);
      });
      let updateWidgetItems = this.widgetItems;
      updateWidgetItems = updateWidgetItems.map(item => ({
        percentValue: item.percentValue,
        startDate: dateConverter.convertToString(item.startDate),
        endDate: dateConverter.convertToString(item.endDate),
      }));
      this.payment.currencyRateIncreasePercents = updateWidgetItems;
    },
    recalculationPercent(percent) {
      if (percent > 100) {
        return 100;
      }
      if (percent < 0) {
        return 0;
      }
      return percent;
    },
    deleteWidgetItems(index) {
      this.widgetItems.splice(index, 1);
    },
    wrappedIndexForStartDate(index) {
      return this.minDateForStartDateFn.bind(undefined, index);
    },
    wrappedIndexForEndDate(index) {
      return this.minDateForEndDateFn.bind(undefined, index);
    },
    minDateForStartDateFn(index, date) {
      if (index > 0) {
        return date <= this.widgetItems[index - 1].endDate || date > dateConverter.convertToDate(this.payment.endDate);
      }
      return date < dateConverter.convertToDate(this.payment.startDate);
    },
    minDateForEndDateFn(index, date) {
      return date < this.widgetItems[index].startDate || date > dateConverter.convertToDate(this.payment.endDate);
    },
    addNewPercentAndPeriod() {
      this.widgetItems.push(
        {
          percentValue: 0,
          startDate: null,
          endDate: null,
        },
      );
    },
  },
};
</script>
